import React from 'react';
import CommonSidebar from "../Common/CommonSidebar";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";

//icons
import WebIcon from '@mui/icons-material/Web';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';


class LearningSidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount() {

    }

    render() {
        return(
            <CommonSidebar
                groups={[ ...[

                        {
                            title: 'Знания',
                            items: [
                                {
                                    title: 'Библиотека',
                                    link: '/material/',
                                    icon: LibraryBooksIcon,
                                },
                                {
                                    title: 'Wiki',
                                    link: '/wiki_page/',
                                    icon: WebIcon,
                                },

                            ]
                        },
                    ],
                ]}
            />
        )
    }
}

export default LearningSidebar;
